import "./style.css";

const DEFAULT_ITEMS = [
  {
    text:
      "Todo ser é dotado de grande potencial e talento que precisam ser desenvolvidos e aperfeiçoados.",
  },
  {
    text: "O contexto condiciona, mas não determina o que uma pessoa vai ser.",
  },
  {
    text: "A educação é a força motriz da transformação.",
  },
];

export default function Crencas({ crencas, editMode, onError, onChange }) {
  const titulo = crencas?.title ?? "Crenças";
  const intro = crencas?.intro ?? "";
  const sourceItems = Array.isArray(crencas?.items) ? crencas.items : [];
  const items = sourceItems.map(
    (item) => (typeof item === "string" ? { text: item } : { text: "", ...item }),
  );
  const editableItems = items.length ? items : DEFAULT_ITEMS;
  const publicItems = items.some((item) => String(item.text || "").trim())
    ? items
    : DEFAULT_ITEMS;

  const handleItemChange = (index, value) => {
    const updatedItems = editableItems.map((item, itemIndex) =>
      itemIndex === index ? { ...item, text: value } : item,
    );
    onChange("items", updatedItems);
  };

  if (editMode) {
    return (
      <section className="crencas">
        <div className="crencas__inner">
          <input
            className="quem-somos-page-h2__input"
            value={titulo || ""}
            onChange={(e) => onChange("title", e.target.value)}
          />
          <textarea
            className="quem-somos-page-p__textarea"
            value={intro || ""}
            onChange={(e) => onChange("intro", e.target.value)}
          />

          <div className="crencas__grade">
            {editableItems.map((item, i) => (
              <div
                key={i}
                className={`crencas__item ${i % 2 === 1 ? "crencas__item--destaque" : ""}`}
              >
                <textarea
                  className="quem-somos-page-p__textarea"
                  value={item.text || ""}
                  onChange={(e) => handleItemChange(i, e.target.value)}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="crencas">
      <div className="crencas__inner">
        <h2 className="crencas__titulo">{titulo}</h2>
        <p className="crencas__intro">{intro}</p>

        <div className="crencas__grade">
          {publicItems.map((item, i) => (
            <div
              key={i}
              className={`crencas__item ${i % 2 === 1 ? "crencas__item--destaque" : ""}`}
            >
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
